import hbDefaultTokens from '@homebotapp/yar/dist/legacy/js/hbDefault.module.js'
import hbDefaultNeutralTokens from '@homebotapp/yar/dist/legacy/js/hbDefaultNeutral.module.js'
import lightTokens from '@homebotapp/yar/dist/legacy/js/light.module.js'
import lightNeutralTokens from '@homebotapp/yar/dist/legacy/js/lightNeutral.module.js'

const HB_DEFAULT = 'hb_default'
const HB_DEFAULT_NEUTRAL = 'hb_default_neutral'
const LIGHT = 'light'
const LIGHT_NEUTRAL = 'light_neutral'

const LIGHT_THEMES = [LIGHT, LIGHT_NEUTRAL]

type ThemeName =
  | typeof HB_DEFAULT
  | typeof HB_DEFAULT_NEUTRAL
  | typeof LIGHT
  | typeof LIGHT_NEUTRAL

type DesignTokens = { [key: string]: string }

export type ThemeType = {
  name?: ThemeName
  tokens: DesignTokens
  isLightThemeType: boolean
}

const createTheme = (name: ThemeName, tokens: DesignTokens) => ({
  name,
  tokens,
  isLightThemeType: LIGHT_THEMES.includes(name),
})

export const themes = {
  [HB_DEFAULT]: createTheme(HB_DEFAULT, hbDefaultTokens),
  [HB_DEFAULT_NEUTRAL]: createTheme(HB_DEFAULT_NEUTRAL, hbDefaultNeutralTokens),
  [LIGHT]: createTheme(LIGHT, lightTokens),
  [LIGHT_NEUTRAL]: createTheme(LIGHT_NEUTRAL, lightNeutralTokens),
}
